import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["data"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import shallowEqual from './utils/shallowEqual';
import updateMultipleDatasetsInView from './utils/updateMultipleDatasetsInView';
import VegaEmbed from './VegaEmbed';
import { NOOP } from './constants';
var EMPTY = {};

var Vega = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Vega, _React$PureComponent);

  var _super = _createSuper(Vega);

  function Vega() {
    var _this;

    _classCallCheck(this, Vega);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "vegaEmbed", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "handleNewView", function (view) {
      _this.update();

      var _this$props$onNewView = _this.props.onNewView,
          onNewView = _this$props$onNewView === void 0 ? NOOP : _this$props$onNewView;
      onNewView(view);
    });

    return _this;
  }

  _createClass(Vega, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!shallowEqual(this.props.data, prevProps.data)) {
        this.update();
      }
    }
  }, {
    key: "update",
    value: function update() {
      var data = this.props.data;

      if (this.vegaEmbed.current && data && Object.keys(data).length > 0) {
        this.vegaEmbed.current.modifyView(function (view) {
          updateMultipleDatasetsInView(view, data);
          view.resize().run();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          restProps = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement(VegaEmbed, _extends({
        ref: this.vegaEmbed
      }, restProps, {
        onNewView: this.handleNewView
      }));
    }
  }]);

  return Vega;
}(React.PureComponent);

export { Vega as default };

_defineProperty(Vega, "defaultProps", {
  data: EMPTY
});